<template>
  <a v-if="href" :href="href" class="sittercity-nav-logo">
    <img src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity logo" />
  </a>
  <router-link v-else-if="to" :to="to" class="sittercity-nav-logo">
    <img src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity logo" />
  </router-link>
  <div v-else class="sittercity-nav-logo">
    <img src="@/images/components/header/sittercity-mark-logo.svg" alt="Sittercity logo" />
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export default {
  name: 'NavigationLogo',
  props: {
    href: {
      type: String,
      default: '',
    },
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.sittercity-nav-logo {
  img {
    height: 30px;
    width: 48px;
  }
  margin-left: 16px;

  @media only screen and (min-width: 768px) {
    img {
      height: unset;
    }
    width: 204px;
    margin-left: 16px;
  }
  @media only screen and (min-width: 1024px) {
    margin-left: 48px;
  }
}
</style>
